module.exports = __webpack_public_path__ + "static/media/company_1.png";